import { Route, Routes } from "react-router-dom";
import { ROUTES } from "../classes/constants/routeConstants";
import { AccessPermissions } from "../classes/enums/PermissionsEnum";
import Align from "../modules/align/Align";
import Check from "../modules/check/Check";
import DigitalTwin from "../modules/digitalTwin/DigitalTwin";
import PatientDashboard from "../modules/patients/PatientDashboard";
import Patients from "../modules/patients/Patients";
import { Settings } from "../modules/settings/Settings";
import Support from "../modules/support/Support";
import Validation from "../modules/validation/Validation";
import Callback from "../pages/Callback";
import ComponentPlayground from "../pages/ComponentPlayground";
import LogoutCallback from "../pages/LogoutCallback";
import MainLayout from "../pages/MainLayout";
import NoPermission from "../pages/NoPermission";
import NotFound from "../pages/NotFound";
import ServerError from "../pages/ServerError";
import StyleGuide from "../pages/StyleGuide";
import PrivateRoute from "../routes/PrivateRoutes";

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/style" element={<StyleGuide />} />
      <Route path="/callback" element={<Callback />} />
      <Route path="/logout-callback" element={<LogoutCallback />} />
      {/* Main layout with protected routes */}
      <Route path="/*" element={<MainLayout />} />
    </Routes>
  );
};

export const routes = [
  {
    path: ROUTES.SUPPORT,
    element: <Support />,
  },
  {
    path: ROUTES.SETTINGS,
    element: <Settings />,
  },
  {
    path: ROUTES.UI_PLAYGROUND,
    element: <ComponentPlayground />,
  },
  {
    path: ROUTES.HOME,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_LIST]}>
        <Patients />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.PATIENTS,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_LIST]}>
        <Patients />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.PATIENT_DASHBOARD,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_DASHBOARD]}>
        <PatientDashboard />
      </PrivateRoute>
    ),
  },
  // Separate Digital Twin routes - all use the same component
  {
    path: ROUTES.DIGITAL_TWIN_SELECTION,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_PLANNING]}>
        <DigitalTwin />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.DIGITAL_TWIN_CREATION,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_PLANNING]}>
        <DigitalTwin />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.DIGITAL_TWIN_SELECTED,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_PLANNING]}>
        <DigitalTwin />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.DIGITAL_TWIN_COMPARISON,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_PLANNING]}>
        <DigitalTwin />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.DIGITAL_TWIN_EDIT,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_PLANNING]}>
        <DigitalTwin />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.VALIDATION,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_PLANNING]}>
        <Validation />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.VALIDATION_WITH_MODE,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_PLANNING]}>
        <Validation />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.CHECK,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_PLANNING]}>
        <Check />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.ALIGN,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_PLANNING]}>
        <Align />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.ALIGN_COMPARISON,
    element: (
      <PrivateRoute requiredPermissions={[AccessPermissions.PATIENT_PLANNING]}>
        <Align />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.NO_PERMISSION,
    element: <NoPermission fallbackRoute={ROUTES.HOME} />,
  },
  {
    path: ROUTES.ERROR,
    element: <ServerError fallbackRoute={ROUTES.HOME} />,
  },
  {
    path: ROUTES.NOT_FOUND,
    element: <NotFound fallbackRoute={ROUTES.HOME} />,
  },
];
